import { createReducer } from '@reduxjs/toolkit'

import { TCustomization } from 'types/GlobalCustomization'

import * as authenticationActions from '../../actions/Authentication/actions'
import * as customizationActions from '../../actions/Admin/Customization/actions'

// Initial state
const INITIAL_STATE: TCustomization = {
  background_colors: null,
  profile_colors: null,
  text_colors: null,
  logotype: null
}

// Reducer
const CustomizationReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(authenticationActions.setSignedIn, (state, action) => {
      const { colors } = action.payload.customer

      return {
        ...state,
        background_colors: colors.background_colors,
        profile_colors: colors.profile_colors,
        text_colors: colors.text_colors,
        logotype: colors.logotype
      }
    })
    .addCase(customizationActions.updateSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        background_colors: {
          default: payload.data.backgroundColor,
          paper: payload.data.widgetBackgroundColor
        },
        profile_colors: {
          primary: payload.data.primaryColor,
          secondary: payload.data.secondaryColor,
          tertiary: payload.data.tertiaryColor,
          quaternary: payload.data.quaternaryColor,
          quintary: payload.data.quintaryColor,
          senary: payload.data.senaryColor,
          septenary: payload.data.septenaryColor,
          octonary: payload.data.octonaryColor,
          nonary: payload.data.nonaryColor,
          denary: payload.data.denaryColor
        },
        text_colors: {
          primary: payload.data.textPrimaryColor,
          secondary: payload.data.textSecondaryColor
        },
        logotype: payload.data.logotype
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default CustomizationReducer
